import store from "@/state/store";

export default [
  {
    path: "/admin/quan-ly-doanh-nghiep",
    name: "Quản lý doanh nghiệp",
    meta: { requiresAuth: true },
    component: () => import("../pages/admin/quanlydoanhnghiep"),
  },
  {
    path: "/admin/danh-sach-doanh-nghiep",
    name: "Danh sách doanh nghiệp",
    meta: { requiresAuth: true },
    component: () => import("../pages/admin/danhsachdoanhnghiep"),
  },
  {
    path: "/admin/danh-sach-chuong-trinh",
    name: "Danh sách chương trình",
    meta: { requiresAuth: true },
    component: () => import("../pages/admin/suKien"),
  },

  {
    path: "/admin/gioi-thieu",
    name: "Giới thiệu",
    meta: { requiresAuth: true },
    component: () => import("../pages/admin/thongtinlehoi"),
  },

  {
    path: "/trai-cay/chi-tiet/:code?",
    name: "Chi tiết sản phẩm trái cây",
    meta: {},
    component: () => import("../pages/public/traiCay/chiTietTraiCay"),
  },
  {
    path: "/trai-cay/danh-sach",
    name: "Danh sách sản phẩm trái cây",
    meta: {},
    component: () => import("../pages/public/traiCay/danhSachTraiCay"),
  },
  {
    path: "/",
    name: "Trang chủ",
    meta: {},
    component: () => import("../pages/public/home/home"),
  },
  {
    path: "/lich-hoat-dong",
    name: "Lịch hoạt động",
    meta: {},
    component: () => import("../pages/public/sukien/danhSachSuKien"),
  },
  {
    path: "/bg",
    name: "default",
    meta: {},
    component: () => import("../pages/public/background"),
  },

  // QUAN TRI

  {
    path: "/login",
    name: "Đăng nhập",
    meta: {},
    component: () => import("../pages/admin/auth/login.vue"),
  },
  {
    path: "/admin/menu",
    name: "menu hệ thống",
    meta: { requiresAuth: true },
    component: () => import("../pages/admin/menu"),
  },

  {
    path: "/admin/tai-khoan",
    name: "Tài khoản",
    meta: { requiresAuth: true },
    component: () => import("../pages/admin/user"),
  },
  {
    path: "/tai-khoan/doi-mat-khau",
    name: "Đổi mật khẩu",
    meta: { requiresAuth: true },
    component: () => import("../pages/admin/user/ChangePass"),
  },
  {
    path: "/admin/menu-cong-dan",
    name: "Menu Công Dân",
    meta: { requiresAuth: true },
    component: () => import("../pages/admin/menucongdan"),
  },
  {
    path: "/admin/vai-tro",
    name: "Quyền",
    meta: { requiresAuth: true },
    component: () => import("../pages/admin/unitRole"),
  },
  {
    path: "/admin/vai-tro/thiet-lap-quyen/:id?",
    name: "Vai trò",
    meta: { requiresAuth: true },
    component: () => import("../pages/admin/unitRole/addPermissions"),
  },

  {
    path: "/admin/nhom-quyen",
    name: "Quản lý nhóm quyền",
    meta: { requiresAuth: true },
    component: () => import("../pages/admin/module"),
  },
  {
    path: "/admin/nhom-quyen/action/:id?",
    name: "Hành động",
    meta: { requiresAuth: true },
    // meta: {},
    component: () => import("../pages/admin/module/action"),
  },
  {
    path: "/thong-tin-ca-nhan",
    name: "Thông tin cá nhân",
    meta: { requiresAuth: true },
    // meta: {},
    component: () => import("../pages/admin/login/profile"),
  },

  {
    path: "/404",
    name: "404",
    component: require("../pages/shared/404").default,
  },
  {
    path: "/unauthorized",
    name: "401",
    component: require("../pages/shared/401").default,
  },
  {
    path: "*",
    redirect: "404",
  },
  {
    path: "/admin/tao-bai-viet",
    name: "Tạo sản phẩm trái cây",
    // meta: {},
    component: () => import("../pages/admin/taobaiviet"),
  },

  {
    path: "/admin/thong-tin-le-hoi",
    name: "Cấu hình thông tin lễ hội",
    meta: { requiresAuth: true },
    component: () => import("../pages/admin/thongtinlehoi"),
  },
  {
    path: "/admin/danh-sach",
    name: "Danh sách sản phẩm trái cây",
    meta: { requiresAuth: true },
    // meta: {},
    component: () => import("../pages/admin/danhsachbaiviet"),
  },
  {
    path: "/danh-sach/chi-tiet/:id?",
    name: "Chi tiết sản phẩm trái cây",
    // meta: {},
    component: () => import("../pages/admin/danhsachbaiviet/capnhatbaiviet"),
  },
  {
    path: "/book",
    name: "Book",
    // meta: {},
    component: () => import("../pages/public/bookIndex.vue"),
  },
  {
    path: "/tin-tuc/chi-tiet/:id?",
    name: "Xem chi tiết bài viết",
    component: () => import("../pages/public/news/ChiTietTinTuc.vue"),
  },

  {
    path: "/admin/tao-tin-dang",
    name: "Tạo tin tức",
    meta: { requiresAuth: true },
    // meta: {},
    component: () => import("../pages/admin/quanLyTinTuc/taoTinTuc.vue"),
  },
  {
    path: "/admin/danh-sach-tin-tuc",
    name: "Danh sách tin tức",
    meta: { requiresAuth: true },
    // meta: {},
    component: () => import("../pages/admin/quanLyTinTuc/index.vue"),
  },
  {
    path: "/danh-sach-tin-tuc/chi-tiet/:id?",
    name: "Chi tiết tin tức",
    // meta: {},
    component: () => import("../pages/admin/quanLyTinTuc/capNhatTinTuc.vue"),
  },
  {
    path: "/admin/danh-muc-tin-tuc",
    name: "Danh mục tin tức",
    meta: { requiresAuth: true },
    component: () => import("../pages/admin/danhMuc/index.vue"),
  },

  {
    path: "/tao-bai-viet",
    name: "Đăng tải bài viết",
    meta: {},
    component: () => import("../pages/public/taoBaiViet.vue"),
  },
];
